import { useLocation } from "wouter";

// Port 1:1 di isActive da ChakraHeader:124-152 (regole /schede↔/scheda/*,
// /archivio↔/foto/*↔/photos/*, audioguide, home esatta).
export function useIsActive() {
  const [location] = useLocation();
  const locationWithoutLang = location.replace(/^\/(it|en|de|sl)/, "") || "/";

  return (path: string): boolean => {
    if (path === "/schede") {
      if (locationWithoutLang === "/schede") {
        return true;
      }
      if (locationWithoutLang.startsWith("/scheda/")) {
        return true;
      }
      return (
        locationWithoutLang.startsWith("/schede/") &&
        !locationWithoutLang.startsWith("/schede/audioguide")
      );
    }

    if (path === "/archivio") {
      return (
        locationWithoutLang === "/archivio" ||
        locationWithoutLang.startsWith("/archivio/") ||
        locationWithoutLang.startsWith("/foto/") ||
        locationWithoutLang.startsWith("/photos/")
      );
    }

    if (path === "/schede/audioguide") {
      return locationWithoutLang.startsWith("/schede/audioguide");
    }

    if (path === "/") {
      return locationWithoutLang === path;
    }
    return locationWithoutLang.startsWith(path);
  };
}
